import React, { useContext, useState, useEffect } from "react";
import { LoanFormContext } from "./LoanForm";
import FormStep from "../../FormStep";
import RateSlider from "../Controls/Slider/RateSlider";
import { Button } from "react-bootstrap";

const PropertyRemainingBalance: React.FunctionComponent<{
  onSubmit?: (value: number[]) => void;
}> = (props: { onSubmit?: (value: number[]) => void }) => {
  const loanFormContext = useContext(LoanFormContext);
  const [lowerBound, setLowerBound] = useState<number>(100000);
  const [upperBound, setUpperBound] = useState<number>(500000);

  useEffect(() => {
    if (loanFormContext.propertyRemainingBalance) {
      console.log("gfg", loanFormContext.propertyRemainingBalance);
      setLowerBound(loanFormContext.propertyRemainingBalance.value.min);
      setUpperBound(loanFormContext.propertyRemainingBalance.value.max);
    }
  }, [loanFormContext.propertyRemainingBalance]);

  const handleSubmit = () => {
    if (props.onSubmit) props.onSubmit([lowerBound, upperBound]);
  };

  return (
    <div>
      <FormStep
        header={
          <h1 className="heading-main">
            What is the remaining 1st mortgage balance?
          </h1>
        }
      >
        <div className="form-inputs-wrapper">
          <div>
            <RateSlider
              value={[lowerBound, upperBound]}
              onChange={(e) => {
                setLowerBound(e[0]);
                setUpperBound(e[1]);
              }}
            />
          </div>
          <div className="mt-5">
            <Button variant="primary" block onClick={handleSubmit}>
              Continue
            </Button>
          </div>
        </div>
      </FormStep>
    </div>
  );
};

export default PropertyRemainingBalance;
